import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Activity, ActivityText } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../../../modules/angular.module';
import { LanguageService } from '../../../../../../services/language.service';

@Component({
	selector: 'app-language-tabs',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './language-tabs.component.html',
	styleUrl: './language-tabs.component.scss',
})
export class LanguageTabsComponent {
	@Output('onTabChange') public onTabChange: EventEmitter<ActivityText> =
		new EventEmitter<ActivityText>();
	@Input('activity') public activity: Activity | undefined;
	@Input('selectedLanguage') public selectedLanguage: string = 'en';

	constructor(public languageService: LanguageService) {}
}
